type ProductTypes = {
  name: string
  link: string
  image: string
}
export const productTypesNew: ProductTypes[] = [
  {
    name: 'homepage.products.table',
    link: '/configurator/table',
    image: '/cdn/table/table-2.webp',
  },
  {
    name: 'homepage.products.bench',
    link: '/bench',
    image: '/cdn/bench/bench.png',
  },
  {
    name: 'homepage.products.rack-2',
    link: '/wooden-rack',
    image: '/cdn/wooden-rack/wooden-rack.png',
  },
  {
    name: 'homepage.products.stool',
    link: '/stool',
    image: '/cdn/stool/stool.png',
  },
]
